import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ToastProvider } from '@wend/ui';

import { App } from './App';
import './index.css';

const container = document.getElementById('root');
if (container === null) {
  throw new Error('#root is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    {/* Mounted once, above the router, as @wend/ui requires. */}
    <ToastProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ToastProvider>
  </StrictMode>,
);
